import { Box, Button, IconButton, Modal, styled, TextareaAutosize, Typography } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";

interface RequestFeatureProps {
    open: boolean,
    onClose: () => void,
}

const StyledTextArea = styled(TextareaAutosize)(() => ({
    width: '100%',
    minHeight: '100px',
    marginTop: '16px',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid var(--Light-Gray)',
    fontFamily: 'inherit',
    fontSize: '14px',
    lineHeight: '20px',
    resize: 'vertical',
    '&:focus': {
        outline: 'none',
    },
}));

const RequestFeature = ({open, onClose} : RequestFeatureProps) => {
    const [request, setRequest] = useState('');

    const sendRequest = useMutation({
        mutationFn: async () => {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                'https://interviewer.runasp.net/api/requested-features/create',
                {
                    description: request,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return response.data;
        },
        onSuccess: (data) => {
            toast.success('Request sent successfully')
            onClose();
        },
        onError: (error) => {
            console.log(error);
        }
    })

    const handleSubmit = () => {
        sendRequest.mutate()
    }
    return (
         <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: {
                        xs: 'calc(100% - 32px)',
                        sm: 'calc(100% - 48px)',
                        md: '588px'
                    },
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: {
                        xs: '24px',
                        sm: '32px',
                        md: '48px'
                    },
                    borderRadius: '16px',
                    textAlign: 'center',
                }}
            >
                <IconButton
                    sx={{ position: 'absolute', top: 8, right: 8 }}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
                <Typography id="modal-title" variant="h1" component="h2" sx={{mt: '24px'}}>
                    Request a feature
                </Typography>
                <Typography id="modal-description" sx={{mt: '8px', mb: '20px'}}>
                     If you have any suggestion we would like to hear from you and implement it as soon as posible
                </Typography>
                <StyledTextArea 
                    placeholder="Type in your suggestion here..." 
                    value={request}
                    onChange={(e) => setRequest(e.target.value)}
                />
                <Button 
                    onClick={handleSubmit} 
                    variant="contained" 
                    color="primary" 
                    sx={{ mt: '24px', width: '100%' }}
                >
                    Submit
                </Button>
            </Box>
        </Modal>
    )
}

export default RequestFeature